import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema, getValidationSchema2 } from '@Shared/utils/validationSchema';
import FirstContactFormMeta from '../../../FirstContactFormMeta';
import SecondContactFormMeta from '../../../SecondContactFormMeta';
import { IContactFormMeta } from '../../../ContactFormMeta';

export interface IBankPromotorFormMeta {
  title: FormInputMeta,
  firstName: FormInputMeta,
  lastName: FormInputMeta,
  moyen: FormInputMeta,
  birthDate: FormInputMeta,
  firstIdentity: FormInputMeta,
  secondIdentity: FormInputMeta,
  sex: FormInputMeta,
  citizen: FormInputMeta,
  birthPlace: FormInputMeta,
  identityType: FormInputMeta,
  identityType2: FormInputMeta,
  materimonialeSituation: FormInputMeta,
  numberChildren: FormInputMeta,

  // Schema
  schema: any,
}

const BankPromotorFormMeta: IBankPromotorFormMeta = {} as IBankPromotorFormMeta

BankPromotorFormMeta.title = {
  name: 'title',
  type: 'select',
  label: 'Titre',
  // placeholder: 'Type Adresse',
  options: [

  ],
  validation: yup.string().required(),
};

BankPromotorFormMeta.firstName = {
  name: 'firstName',
  type: 'text',
  label: 'Prénom',
  placeholder: 'Prénom',
  validation: yup.string().required(),
};

BankPromotorFormMeta.moyen = {
  name: 'moyen',
  type: 'text',
  label: 'Moyen',
  placeholder: 'Moyen',
  validation: yup.string().required(),
};

BankPromotorFormMeta.lastName = {
  name: 'lastName',
  type: 'text',
  label: 'Nom',
  placeholder: 'Nom',
  validation: yup.string().required(),
};

BankPromotorFormMeta.birthDate = {
  name: 'birthDate',
  type: 'text',
  label: 'Date de naissance',
  placeholder: 'Date de naissance',
  validation: yup.string().required(),
};

BankPromotorFormMeta.birthPlace = {
  name: 'birthPlace',
  type: 'text',
  label: 'Lieu de naissance',
  placeholder: 'Lieu de naissance',
  validation: yup.string().required(),
};

BankPromotorFormMeta.firstIdentity = {
  name: 'firstIdentity',
  type: 'text',
  label: 'Première Identité',
  placeholder: 'Première Identité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.secondIdentity = {
  name: 'secondIdentity',
  type: 'text',
  label: 'Deuxième Identité',
  placeholder: 'Deuxième Identité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.identityType = {
  name: 'identityType',
  type: 'select',
  label: 'Type Identité',
  placeholder: 'Type Identité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.identityType2 = {
  name: 'identityType2',
  type: 'select',
  label: 'Type Identité',
  placeholder: 'Type Identité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.materimonialeSituation = {
  name: 'materimonialeSituation',
  type: 'select',
  label: 'Situation Matrimoniale',
  options: [
    {
      label: 'Célibataire',
      value: 'single',
    },
    {
      label: 'Marié(e)',
      value: 'maried',
    },
  ],
  // placeholder: 'Type Identité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.numberChildren = {
  name: 'numberChildren',
  type: 'text',
  label: 'Nombre Enfants',
  placeholder: 'Nombre Enfants',
  validation: yup.string().required(),
};

BankPromotorFormMeta.citizen = {
  name: 'citizen',
  type: 'text',
  label: 'Nationalité',
  placeholder: 'Nationalité',
  validation: yup.string().required(),
};

BankPromotorFormMeta.sex = {
  name: 'Sexe',
  type: 'select',
  label: 'Sexe',
  options: [
    {
      label: 'Homme',
      value: 'male',
    },
    {
      label: 'Femme',
      value: 'female',
    },
  ],
  // placeholder: 'Nombre Enfants',
  validation: yup.string().required(),
};

const validationSchema = getValidationSchema(BankPromotorFormMeta);

BankPromotorFormMeta.schema = yup.object().shape(validationSchema);

export default BankPromotorFormMeta;